export const CREATE_PROJECT_GENERAL_INFO_STEP = 0
export const CREATE_PROJECT_IMAGES_STEP = 1
export const CREATE_PROJECT_PARKING_STEP = 2
export const CREATE_PROJECT_COLORS_STEP = 3
export const CREATE_PROJECT_UPGRADE_STEP = 4
export const CREATE_PROJECT_PAYMENT_STEP = 5
